import React, { Component } from "react";

class CarouselBox extends Component {
  render() {
    const { carousel } = this.props;
    return (
      <li key={`key-${carousel.idx}`} style={{backgroundImage: `url(${carousel.pic_path})`}}>
        <div className="container">
          <div className="row">
              <div className="col-md-6 col-md-pull-3 col-sm-12 col-xs-12 col-md-offset-3 slider-text"> </div>
          </div>
        </div>
      </li>
    );
  }
}

export default CarouselBox;
